'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../app/store';

import { FilterSummary } from '../features/cfs-search/filter-summary.jsx';
import { FilterContent } from '../features/cfs-search/filter-content.jsx';
import { NavigatedFilterButtons } from '../features/cfs-search/navigated-filter-buttons.jsx';
import { Results } from '../features/cfs-search/results.jsx';
import { SortButtons } from '../features/cfs-search/sort-buttons.jsx';

export function renderSearch() {
	const $cfsSearchResults = $.findByBem('cfs-search-results');
	const initialState = $cfsSearchResults.data('initial-state');
	const isNew = $cfsSearchResults.data('is-new');
	const selectedSort = $cfsSearchResults.data('selected-sort');
	const openFilters = $cfsSearchResults.data('open-filters');

	const filterContentRoot = ReactDOM.createRoot(document.getElementById('filter-content'));
	filterContentRoot.render(
		<Provider store={store}>
			<FilterContent />
		</Provider>
	);

	const filterSummaryRoot = ReactDOM.createRoot(document.getElementById('filter-summary'));
	filterSummaryRoot.render(
		<Provider store={store}>
			<FilterSummary initialState={initialState} isNew={isNew} openByDefault={!!openFilters} />
		</Provider>
	);

	const navigatedFilterButtonsRoot = ReactDOM.createRoot(document.getElementById('navigated-filter-buttons'));
	navigatedFilterButtonsRoot.render(
		<Provider store={store}>
			<NavigatedFilterButtons />
		</Provider>
	);

	const sortButtonsRoot = ReactDOM.createRoot(document.getElementById('sort-buttons'));
	sortButtonsRoot.render(
		<Provider store={store}>
			<SortButtons selectedSort={selectedSort} />
		</Provider>
	);

	const resultsRoot = ReactDOM.createRoot(document.getElementById('cfsResults'));
	resultsRoot.render(
		<Provider store={store}>
			<Results />
		</Provider>
	);
}